// extracted by mini-css-extract-plugin
module.exports = {"title":"e_EF","excerpt":"e_FF","container":"e_GF","imageContainer":"e_HF","image":"e_IF","postedBy":"e_JF","postedByDate":"e_KF"};